export default __webpack_public_path__ + "static/media/el_sotsiaalfond_horisontaalne.c00be66f.jpg";